(() => {
  const initializePurposeAnimation = (section) => {
    if (!section || section.dataset.purposeAnimationInitialized === 'true') return;

    section.dataset.purposeAnimationInitialized = 'true';

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
      section.classList.add('is-visible');
      return;
    }

    section.classList.add('is-animation-ready');

    const observer = new IntersectionObserver(
      (entries) => {
        if (!entries[0].isIntersecting) return;

        section.classList.add('is-visible');
        observer.unobserve(section);

        const animatedItem = section.querySelector('.ft-purpose__item');
        let cleanupTimer;
        const clearWillChange = () => {
          window.clearTimeout(cleanupTimer);
          section.classList.add('is-animation-complete');
          animatedItem?.removeEventListener('transitionend', handleTransitionEnd);
        };
        const handleTransitionEnd = (event) => {
          if (event.propertyName === 'transform') clearWillChange();
        };

        animatedItem?.addEventListener('transitionend', handleTransitionEnd);
        cleanupTimer = window.setTimeout(clearWillChange, 1800);
      },
      { threshold: 0.12, rootMargin: '0px 0px -5% 0px' }
    );

    observer.observe(section);
  };

  const initializeAllPurposeAnimations = (root = document) => {
    root.querySelectorAll('.ft-purpose').forEach(initializePurposeAnimation);
  };

  initializeAllPurposeAnimations();

  document.addEventListener('shopify:section:load', (event) => {
    initializeAllPurposeAnimations(event.target);
  });
})();
